import { useContext } from "react";
import { t } from "i18next";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { iconButtonStyles } from "../../../../components/Modal/ModalHeader";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import CapturedImagesIcon from "../../../../components/SVGComponents/CapturedImagesIcon";

// Opens the captured / key-images popup from the agentic LLMTopBar toolbar. The modal itself is
// rendered in CustomEditor; we only flip the shared studyReportContext flag here. Clearing the
// "new captures" badge state mirrors the standard-editor trigger in CustomEditor.
const CapturedImagesButton = () => {
  const {
    setShowCapturedImagesModal,
    hasNewCapturedImage,
    setHasNewCapturedImage,
    newCapturedImageCount,
    setNewCapturedImageCount,
  } = useContext(studyReportContext);

  const openModal = () => {
    setShowCapturedImagesModal(true);
    if (hasNewCapturedImage) setHasNewCapturedImage(false);
    if (newCapturedImageCount > 0) setNewCapturedImageCount(0);
  };

  return (
    <CustomToolTipHost
      content={t("captured-images-tab.tab-label")}
      id="CapturedImages"
      tooltipProps={{
        calloutProps: {
          styles: {
            beak: { background: "#252525;" },
            beakCurtain: { background: "#252525;" },
            calloutMain: { background: "#252525;" },
            borderRadius: "20%",
          },
        },
      }}
    >
      <div
        className="highlight-tool-llm"
        styles={iconButtonStyles}
        onClick={openModal}
        style={{ cursor: "pointer", marginTop: "2px", position: "relative" }}
        aria-label={t("captured-images-tab.tab-label")}
      >
        <CapturedImagesIcon />
        {newCapturedImageCount > 0 && (
          <span
            style={{
              position: "absolute",
              top: -2,
              right: -2,
              minWidth: 14,
              height: 14,
              padding: "0 3px",
              borderRadius: 7,
              background: "#d13438",
              color: "#fff",
              fontSize: 9,
              lineHeight: "14px",
              fontWeight: 600,
              textAlign: "center",
              boxSizing: "border-box",
              pointerEvents: "none",
            }}
          >
            {newCapturedImageCount > 99 ? "99+" : newCapturedImageCount}
          </span>
        )}
      </div>
    </CustomToolTipHost>
  );
};

export default CapturedImagesButton;
